import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BrowserSnifferService } from '../../../../services/browser-sniffer.service';
import { FileUploaderComponent, UploaderFile } from '../../../file-uploader/file-uploader.component';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * This component has common logic with "file-uploader" but behaves differently
 */

@Component({
  selector: 'tt-trace-uploader',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule
  ],
  templateUrl: './trace-uploader.component.html',
  styleUrls: ['./trace-uploader.component.scss'],
  standalone: true
})
export class TraceUploaderComponent extends FileUploaderComponent implements OnInit {

  @Output() onReadyForGpxImportEvent = new EventEmitter<any>();

  constructor(
    public browsersniffer: BrowserSnifferService,
    public translateService: TranslateService
  ) {
    super(browsersniffer, translateService);
  }

  override ngOnInit() {
    if (!this.multiple) {
      this.maxFilesToUpload = 1;
      this.showFileList = false;
    }
    this.handleErrorEvent().subscribe();
  }

  override importFiles(files: Array<File>) {
    this.clearFileList();
    this.startLoading();

    if (this.isFileNumberExceeded(files.length + this.importedFiles.length)) {
      this.showImportError("file-uploader.number-files-exceeded");
      this.resetLoading();
      return;
    }
    let file: File = files[0];
    if (!this.fileHasValidExtension(file)) {
      this.showImportError("file-uploader.invalid-extension");
      this.resetLoading();
      return;
    }
    let fileToAdd: UploaderFile = {
      file: file,
      errors: this.validateFileAndReturnErrorMessages(file)
    };
    this.importedFiles.push(fileToAdd)
    this.onReadyForGpxImportEvent.emit();
  }

}
